import logoImg from "@/assets/fabrirent-logo.png";

export const FgLogo = ({ size = 36, className = "" }) => (
  <img
    src={logoImg}
    alt="FabriRent logo"
    style={{ width: size, height: size }}
    className={`shrink-0 object-contain ${className}`}
    data-testid="fg-logo"
  />
);

export default FgLogo;
